<template>
    <div>
        <div class="max-w-6xl mx-auto px-4 py-8">
            <!-- STATS -->
            <div class="grid grid-cols-3 gap-6 mb-8">

                <div class="bg-white p-6 rounded-xl shadow">
                    <p class="text-sm text-gray-500">Crédits restants</p>
                    <p class="text-3xl font-bold mt-2"
                        :class="stats.sms_credits <= 5 ? 'text-red-600' : 'text-gray-800'">
                        {{ stats.sms_credits }}
                    </p>
                </div>

                <div class="bg-white p-6 rounded-xl shadow">
                    <p class="text-sm text-gray-500">Total SMS</p>
                    <p class="text-3xl font-bold mt-2 text-gray-800">
                        {{ stats.total_sms }}
                    </p>
                </div>

                <div class="bg-white p-6 rounded-xl shadow">
                    <p class="text-sm text-gray-500">Envoyés</p>
                    <p class="text-3xl font-bold mt-2 text-green-600">
                        {{ stats.total_sent }}
                    </p>
                </div>

            </div>

            <!-- CREDIT -->
            <div class="bg-white p-6 rounded-xl shadow mb-8">
                <h2 class="font-semibold mb-4">Créditer des SMS</h2>

                <div class="flex gap-4 items-center">
                    <input v-model.number="creditAmount"
                            type="number"
                            min="1"
                            class="border rounded px-3 py-2 w-32">
                    <button
                        @click="creditSms"
                        class="px-4 py-2 bg-orange-600 text-white rounded">
                        Ajouter
                    </button>
                </div>
            </div>

            <!-- HISTORIQUE -->
            <div class="bg-white shadow rounded-xl overflow-hidden">

                <table class="min-w-full divide-y divide-gray-200">
                    <thead class="bg-gray-50">
                        <tr>
                            <th class="px-6 py-3 text-left text-xs text-gray-500 uppercase">Date</th>
                            <th class="px-6 py-3 text-left text-xs text-gray-500 uppercase">Téléphone</th>
                            <th class="px-6 py-3 text-left text-xs text-gray-500 uppercase">Message</th>
                            <th class="px-6 py-3 text-left text-xs text-gray-500 uppercase">Statut</th>
                        </tr>
                    </thead>

                    <tbody class="divide-y divide-gray-200">

                        <tr v-for="sms in stats.messages" :key="sms.id">
                            <td class="px-6 py-4 text-sm text-gray-600">
                                {{ new Date(sms.created_at).toLocaleString() }}
                            </td>
                            <td class="px-6 py-4 text-sm text-gray-600">
                                {{ sms.tel }}
                            </td>
                            <td class="px-6 py-4 text-sm text-gray-600 truncate max-w-xs">
                                {{ sms.message }}
                            </td>
                            <td class="px-6 py-4 text-sm">
                                <span v-if="sms.sent" class="text-green-600 font-semibold">
                                    Envoyé
                                </span>
                                <span v-else class="text-orange-600 font-semibold">
                                    En attente
                                </span>
                            </td>
                        </tr>

                    </tbody>
                </table>

            </div>

        </div>
    </div>
</template>

<script>
export default {

    data() {
        return {
            societeId: this.$route.params.id,
            stats: {
                sms_credits: 0,
                total_sms: 0,
                total_sent: 0,
                messages: []
            },
            creditAmount: 0
        }
    },

    mounted() {
        this.loadStats()
    },

    methods: {

        async loadStats() {
            let res = await this.$request.post('/admin/societes/sms-stats', {
                societe_id: this.societeId
            })
            this.stats = res
        },

        async creditSms() {
            if (!this.creditAmount || this.creditAmount < 1) return

            if (confirm(`Ajouter ${this.creditAmount} crédits SMS à cette société ?`)) {

                let res = await this.$request.post('/admin/societes/sms-credit', {
                    societe_id: this.societeId,
                    amount: this.creditAmount
                })

                this.$toast.success('SMS crédités')
                this.stats.sms_credits = res.new_balance
            }
        }
    }
}
</script>
